import "./spinner.css";
import template from "./spinner.html";

export function insertSpinner(container: HTMLElement) {
  container.innerHTML = template;
}

export function getSpinnerHtml() {
  return template;
}
